import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Divider,
  Container,
} from "@material-ui/core";

import { ROUTER } from "../../../constants";
import { useScreenSize } from "../../../hooks/useScreenSize";

import tut from "../../../assets/image/home/tutorial-icon.png";
import CeremonyGallery from "../CeremonyGallery/CeremonyGallery";
import backdrop from "../../../assets/image/home/backdrop.jpg";
import logoDoan from "../../../assets/image/home/logoDoan.png";
import paperIcon from "../../../assets/image/home/paper-icon.png";
import logoBoKHCN from "../../../assets/image/home/logoBoKHCN.png";
import bannerTitle from "../../../assets/image/home/ptns-banner-title.png";
import registerIcon from "../../../assets/image/home/register-icon.png";

const topicList = [
  {
    key: "thanh-tích",
    title: "Quy chế xét giải thưởng",
    containerColor: "#F5F1EE",
    bgcolor: "#eb564b",
    imgSource: paperIcon,
    // NSKH 2026: bấm "Chi tiết" điều hướng sang trang Quy chế riêng (không scroll xuống)
    to: ROUTER.QUY_CHE,
    description:
      "Giải thưởng Nữ sinh khoa học công nghệ Việt Nam ban hành kèm theo Quyết định số 153-QĐ/TWĐTN-KHCN ngày 01/06/2023 v/v ban hành Quy chế Giải thưởng Nữ sinh khoa học công nghệ Việt Nam và Quyết định số 648 -QĐ/TWĐTN-KHCN ngày 23/08/2024 v/v sửa đổi, bổ sung Quy chế Giải thưởng Nữ sinh khoa học công nghệ Việt Nam của Ban Bí thư Trung ương Đoàn TNCS Hồ Chí Minh ",
  },
  {
    key: "dang-ky",
    title: "Đăng ký",
    containerColor: "#EFEEF5",
    bgcolor: "#3ca370",
    imgSource: registerIcon,
    to: ROUTER.DANG_KY_HO_SO,
    description:
      "Đăng ký tham gia hệ thống bằng việc hoàn thiện hồ sơ đăng ký.",
  },
  {
    key: "binh-chọn",
    title: "Hướng dẫn đăng ký",
    containerColor: "#F4F5EE",
    bgcolor: "#ffe478",
    imgSource: tut,
    to: "/hdsd.pdf",
    description: "Vui lòng ấn vào Chi tiết bên dưới để xem hướng dẫn sử dụng!",
  },
];

function GioiThieu() {
  const isMobileMode = useScreenSize();

  return (
    <>
      <Box
        mb={2}
        style={{
          backgroundImage: `url(${backdrop})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container maxWidth="lg">
          <Box
            paddingY={6}
            display="flex"
            alignItems="center"
            flexDirection={isMobileMode ? "column" : "row"}
          >
            <Box display="flex">
              <img
                src={logoDoan}
                alt="logo-doan"
                style={{ minWidth: 64, width: "calc(100vw / 20)" }}
              />
              <img
                src={logoBoKHCN}
                alt="logo-bo-khcn"
                style={{
                  minWidth: 64,
                  width: "calc(100vw / 20)",
                  marginTop: 10,
                }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              style={{ flexGrow: 1 }}
            >
              <img
                src={bannerTitle}
                alt="title"
                style={{
                  marginLeft: isMobileMode ? 0 : 8,
                  width: isMobileMode ? "100%" : "calc(100% - 100vw / 30)",
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          alignContent="center"
          justifyContent="center"
        >
          {topicList.map((e) => (
            <Grid key={e.key} item xs={12} md={4}>
              <Card
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  display="flex"
                  paddingY={4}
                  justifyContent="center"
                  alignItems="center"
                  bgcolor={e.containerColor}
                >
                  <CardMedia
                    src={e.imgSource}
                    component="img"
                    style={{ width: "45%" }}
                  />
                </Box>
                <CardContent style={{ flexGrow: 1, textAlign: "justify" }}>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: 24,
                      marginBottom: 8,
                      textAlign: "center",
                    }}
                  >
                    <b>{e.title}</b>
                  </Typography>
                  <Box style={{ color: "#55626a", lineHeight: "1.68421053em" }}>
                    {e.description}
                  </Box>
                </CardContent>
                <CardActions>
                  <a href={e.to} style={{ margin: "auto", color: "#ee6064" }}>
                    <b>Chi tiết</b>
                  </a>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Container maxWidth="md">
        <Divider
          style={{
            width: 64,
            height: 4,
            backgroundColor: "#ee6064",
            margin: "64px auto 16px",
          }}
        />
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontFamily: "WorkSans-ExtraBold",
            marginBottom: 24,
          }}
        >
          <b>Giới thiệu Giải thưởng Nữ sinh Khoa học công nghệ Việt Nam</b>
        </Typography>
        <Box
          className="formal-text"
          style={{ color: "#55626a", textAlign: "justify", lineHeight: 1.7 }}
        >
          <p>
            <strong>
              Giải thưởng Nữ sinh Khoa học công nghệ Việt Nam tiền thân là{" "}
            </strong>
            <em>
              “Phần thưởng dành cho nữ sinh viên tiêu biểu trong lĩnh vực công
              nghệ thông tin”
            </em>{" "}
            <strong>
              do Trung ương Đoàn TNCS Hồ Chí Minh chủ trì phối hợp với Bộ Khoa
              học và Công nghệ sáng lập, tổ chức thường niên từ năm 1997 nhằm
              tuyên dương những nữ sinh viên có thành tích học tập, nghiên cứu
              xuất sắc trong các lĩnh vực khoa học công nghệ, góp phần đào tạo
              nguồn nhân lực khoa học công nghệ nữ chất lượng cao phục vụ sự
              nghiệp phát triển đất nước.
            </strong>
          </p>
          <p>
            <strong>Giai đoạn 1997 – 2010:</strong>{" "}
            <em>
              “Phần thưởng dành cho nữ sinh viên tiêu biểu trong lĩnh vực công
              nghệ thông tin”
            </em>{" "}
            được triển khai và trao tặng cho 40 nữ sinh viên có thành tích xuất
            sắc trong học tập, nghiên cứu lĩnh vực công nghệ thông tin. Phần
            thưởng góp phần khuyến khích phong trào học tập, nghiên cứu, ứng dụng
            công nghệ thông tin và đào tạo nguồn nhân lực phục vụ sự nghiệp công
            nghiệp hóa, hiện đại hóa đất nước.
          </p>
          <p>
            <strong>Giai đoạn 2011 – 2021:</strong> Phần thưởng được đổi tên
            thành{" "}
            <em>
              “Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực khoa học kỹ
              thuật”
            </em>
            , sau đó là{" "}
            <em>
              “Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực khoa học công
              nghệ”
            </em>
            . Mỗi năm trao tặng cho 20 nữ sinh viên xuất sắc thuộc 4 lĩnh vực
            đào tạo gồm: công nghệ thông tin, điện, điện tử và cơ khí.
          </p>
          <p>
            <strong>Giai đoạn 2022 – 2023:</strong> Giải thưởng chính thức mang
            tên{" "}
            <em>“Giải thưởng Nữ sinh Khoa học công nghệ Việt Nam”</em>, đánh dấu
            bước phát triển mới về quy mô và uy tín. Phạm vi xét giải được mở
            rộng cho 20 nữ sinh viên thuộc 15 ngành đào tạo chiến lược như: công
            nghệ thông tin, an toàn thông tin, khoa học máy tính, kỹ thuật điện,
            công nghệ sinh học... nhằm đáp ứng yêu cầu chuyển đổi số và cuộc Cách
            mạng công nghiệp lần thứ tư theo tinh thần Nghị quyết Đại hội đại
            biểu toàn quốc lần thứ XIII của Đảng.
          </p>
          <p>
            <strong>Giai đoạn 2024 – 2025:</strong> Cơ cấu xét giải tiếp tục được
            mở rộng từ 15 ngành đào tạo thành 8 nhóm ngành gồm: [1] Công nghệ
            thông tin; [2] Máy tính; [3] Công nghệ kỹ thuật, cơ khí; [4] Công
            nghệ, kỹ thuật điện, điện tử và viễn thông; [5] Công nghệ hóa học,
            vật liệu, luyện kim và môi trường; [6] Sinh học ứng dụng; [7] Công
            nghệ kỹ thuật kiến trúc và công trình xây dựng; [8] Các ngành liên
            quan như công nghệ biển, năng lượng, công nghệ vũ trụ, phòng tránh
            thiên tai và ứng phó với biến đổi khí hậu.
          </p>
          <p>
            Trải qua 28 năm tổ chức, phần thưởng và giải thưởng đã thu hút hàng
            nghìn nữ sinh viên xuất sắc đến từ các trường đại học, học viện trên
            cả nước tham gia. Tính đến năm 2025, đã có 779 nữ sinh viên được vinh
            danh. Nhiều thế hệ nữ sinh đạt giải hiện đã trở thành các nhà khoa
            học, giảng viên, chuyên gia, kỹ sư đang công tác tại các cơ quan, đơn
            vị, doanh nghiệp khoa học và công nghệ, viện nghiên cứu, trường đại
            học trong và ngoài nước, đóng góp tích cực vào sự phát triển và hội
            nhập của khoa học, công nghệ và đổi mới sáng tạo Việt Nam.
          </p>
        </Box>
        <Divider
          style={{
            width: 64,
            height: 4,
            backgroundColor: "#ee6064",
            margin: "64px auto 16px",
          }}
        />
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontFamily: "WorkSans-ExtraBold",
            marginBottom: 24,
          }}
        >
          <b>Một số hình ảnh lễ trao <br />Giải thưởng Nữ sinh KHCN Việt Nam</b>
        </Typography>
        <CeremonyGallery />
      </Container>
    </>
  );
}

export default GioiThieu;
